import React, { lazy } from 'react';

const SystemSettingsSubmenu = lazy(() =>
  import('./SystemSettingsSubmenu').then(module => ({
    default: module.SystemSettingsSubmenu,
  })),
);

const SMTPForm = lazy(() =>
  import('./SMTP/SMTPForm').then(module => ({
    default: module.SMTPForm,
  })),
);

const systemSettingsRoutes = [
  {
    props: { exact: true, path: '/system-settings' },
    component: <SystemSettingsSubmenu />,
  },
  {
    props: { exact: true, path: '/system-settings/smtp-settings' },
    component: <SMTPForm />,
  },
];

export default systemSettingsRoutes;
